import CreateAccountForm from "./CreateAccountForm.js"

export default CreateAccountForm
